/* CL Free Fabric Samples — selection + cart. Vanilla, no dependencies. */
(function () {
  'use strict';

  if (window.customElements && customElements.get('cl-fabric-selector')) return;

  var CartRoutes = (window.FoxTheme && window.FoxTheme.routes) || window.routes || {};
  var ADD_URL = (CartRoutes.cart_add_url || '/cart/add') + '.js';
  var CART_URL = CartRoutes.cart_url || '/cart';

  function t(el, key, fallback) {
    var value = el.getAttribute('data-text-' + key);
    return value && value.length ? value : fallback;
  }

  if (typeof HTMLElement !== 'function' || !window.customElements) return;

  class ClFabricSelector extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.limit = parseInt(this.dataset.limit, 10) || 7;
      this.afterAdd = this.dataset.afterAdd || 'cart';
      this.selected = [];

      this.counter = this.querySelector('[data-cl-fs-count]');
      this.slots = this.querySelector('[data-cl-fs-slots]');
      this.button = this.querySelector('[data-cl-fs-add]');
      this.status = this.querySelector('[data-cl-fs-status]');
      this.swatches = Array.prototype.slice.call(this.querySelectorAll('[data-cl-fs-swatch]'));

      this.swatches.forEach(function (swatch) {
        swatch.addEventListener('click', this.toggle.bind(this, swatch));
      }, this);

      if (this.button) this.button.addEventListener('click', this.addToCart.bind(this));

      this.render();
    }

    /* ---------------------------------------------------------------- */

    indexOfVariant(id) {
      for (var i = 0; i < this.selected.length; i += 1) {
        if (this.selected[i].id === id) return i;
      }
      return -1;
    }

    toggle(swatch) {
      if (swatch.disabled) return;

      var id = swatch.getAttribute('data-variant-id');
      if (!id) return;

      var existing = this.indexOfVariant(id);

      if (existing > -1) {
        this.selected.splice(existing, 1);
        this.setStatus('');
      } else if (this.selected.length < this.limit) {
        var img = swatch.querySelector('img');
        this.selected.push({
          id: id,
          name: swatch.getAttribute('data-name') || '',
          category: swatch.getAttribute('data-category') || '',
          image: img ? img.currentSrc || img.src : ''
        });
        this.setStatus('');
      } else {
        this.setStatus(
          t(this, 'limit', 'You can choose up to ' + this.limit + ' swatches.').replace('[limit]', this.limit)
        );
        return;
      }

      this.render();
    }

    remove(id) {
      var index = this.indexOfVariant(id);
      if (index > -1) this.selected.splice(index, 1);
      this.setStatus('');
      this.render();
    }

    setStatus(message, isError) {
      if (!this.status) return;
      this.status.textContent = message || '';
      this.status.classList.toggle('cl-fs__status--error', Boolean(isError));
    }

    /* ---------------------------------------------------------------- */

    render() {
      var self = this;

      if (this.counter) this.counter.textContent = String(this.selected.length);
      if (this.button) this.button.disabled = this.selected.length === 0;

      // Pressed state + block anything beyond the limit
      var atLimit = this.selected.length >= this.limit;
      this.swatches.forEach(function (swatch) {
        var isOn = self.indexOfVariant(swatch.getAttribute('data-variant-id')) > -1;
        swatch.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        if (swatch.hasAttribute('data-unavailable')) return;
        swatch.disabled = atLimit && !isOn;
      });

      // Per-category summary of chosen fabric names
      this.querySelectorAll('[data-cl-fs-row]').forEach(function (row) {
        var key = row.getAttribute('data-category');
        var target = row.querySelector('[data-cl-fs-chosen]');
        if (!target) return;
        var names = self.selected
          .filter(function (item) { return item.category === key; })
          .map(function (item) { return item.name; });
        target.textContent = names.join(', ');
      });

      // Slots
      if (!this.slots) return;
      this.slots.innerHTML = '';

      this.selected.forEach(function (item) {
        var slot = document.createElement('div');
        slot.className = 'cl-fs__slot';

        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.name;
          img.loading = 'lazy';
          slot.appendChild(img);
        }

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cl-fs__remove';
        remove.setAttribute('aria-label', t(self, 'remove', 'Remove [name]').replace('[name]', item.name));
        remove.textContent = '\u00d7';
        remove.addEventListener('click', function () { self.remove(item.id); });
        slot.appendChild(remove);

        self.slots.appendChild(slot);
      });

      for (var i = this.selected.length; i < this.limit; i += 1) {
        var placeholder = document.createElement('span');
        placeholder.className = 'cl-fs__placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        this.slots.appendChild(placeholder);
      }
    }

    /* ---------------------------------------------------------------- */

    addToCart() {
      if (!this.selected.length) return;

      var self = this;
      var original = this.button.textContent;

      this.button.disabled = true;
      this.button.textContent = t(this, 'adding', 'Adding…');
      this.setStatus('');

      var payload = {
        items: this.selected.map(function (item) {
          return { id: Number(item.id), quantity: 1 };
        })
      };

      fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'add_failed');
            return data;
          });
        })
        .then(function () {
          // Let the theme know the cart changed, whichever cart UI it uses.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

          if (self.afterAdd === 'stay') {
            self.selected = [];
            self.render();
            self.button.textContent = original;
            self.setStatus(t(self, 'added', 'Your swatches have been added to your cart.'));
            return;
          }

          window.location.href = CART_URL;
        })
        .catch(function (error) {
          self.button.disabled = false;
          self.button.textContent = original;
          self.setStatus(
            (error && error.message && error.message !== 'add_failed')
              ? error.message
              : t(self, 'error', 'We could not add your swatches. Please try again.'),
            true
          );
        });
    }
  }

  customElements.define('cl-fabric-selector', ClFabricSelector);
})();